import { useContext } from 'react';

import { CategoricalBarChartValueAxisContext } from '../contexts/CategoricalBarChartValueAxis.context.js';

export const useCategoricalBarChartValueAxisConfig = () =>
  useContext(CategoricalBarChartValueAxisContext);
